import { makeStyles } from 'tss-react/mui';
import { colors } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    discountBlock: {
        width: '100%',
    },
    discountContainer: {
        backgroundColor: '#CBFFE4',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
    },
    iconContainer: {
        marginRight: '4px',
    },
    appliedIcon: {
        content: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' height='20px' viewBox='0 -960 960 960' width='20px' fill='white'%3e%3cpath d='M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z'/%3e%3c/svg%3e")`,
        backgroundColor: '#000',
        borderRadius: '50%',
        height: '20px',
        width: '20px',
        margin: '2px',
    },
    iconClass: {
        backgroundColor: colors.background.BLACK,
        borderRadius: '50%',
        height: '20px',
        width: '20px',
    },
    discountText: Object.assign(Object.assign({}, theme.typography.xxs_bold), { color: colors.grey.grey6 }),
}));
export default useStyles;
